// React
import React, { useState, useEffect } from "react";
import { translate } from "../../utils/translation";
import PropTypes from "prop-types";

// API
import { useLocations } from "../../api/admin/RegionManagementAPI";
import Modal from "../modal/Modal";

// Components
import { RegionSelect } from "../locations/LocationSelect";
import CreateProjectSelectCostManager from "../project-create/CreateProjectSelectCostManager";
import {
  DisplayNameUser,
  FileTray,
  DisplayError,
  onConsent,
  Upload,
} from "./CompanyCreate.components";

// Functions
import { uploadFile } from "./CompanyEdit.functions";
import isEmpty from "../../validation/is-empty";
import { ImageUpload } from "../images/ImageUpload";
import { displayCompanyImage } from "../../validation/image-clean";

// Styles
import "./CompanyCreate.css";
import "./CompanyEdit.css";
import { getUsersByIDs } from "../../api/users/UserAPI";

CompanyEdit.propTypes = {
  show: PropTypes.bool,
  setShow: PropTypes.func,
  company: PropTypes.object,
  companies: PropTypes.array,
  setParentModalShow: PropTypes.func,
};

export default function CompanyEdit(props) {
  // Props
  const { show } = props;
  const { setShow } = props;
  const { company } = props;
  const { companies } = props;
  const { setParentModalShow } = props;
  const { locations } = useLocations(show);

  // State
  const [file, setFile] = useState(null);
  const [error, setError] = useState({});
  const [companyName, setCompanyName] = useState("");
  const [companyEmailDomain, setCompanyEmailDomain] = useState("");
  const [companyAddress, setCompanyAddress] = useState("");
  const [region, setRegion] = useState("");
  const [isGlobal, setIsGlobal] = useState(0);
  const [accountLead, setAccountLead] = useState({});
  const [existingLogo, setExistingLogo] = useState("");

  useEffect(() => {
    if (!isEmpty(company)) {
      setCompanyName(company.name);
      setCompanyEmailDomain(company.email_domain);
      setCompanyAddress(company.address);
      setRegion(company.region);
      setIsGlobal(company.is_global);
      setExistingLogo(displayCompanyImage(company));
    }
  }, [company]);

  //set account lead
  useEffect(() => {
    if (!isEmpty(company)) {
      async function getUser() {
        const user = await getUsersByIDs([company.account_lead]);
        if (!isEmpty(user)) {
          setAccountLead(user[0]);
        }
      }
      getUser();
    }
  }, [company]);

  let data = {
    file: file,
    field: {
      companyID: company?.id,
      name: companyName,
      email_domain: companyEmailDomain,
      address: companyAddress,
      region: region,
      is_global: isGlobal,
      account_lead: accountLead?.id,
    },
    setError: setError,
    setShow: setShow,
    setParentModalShow: setParentModalShow,
    companies: companies,
  };

  return (
    <div className="company-create-container">
      <div className="company-create-inputs">
        <div className="company-create-field">
          <div className="company-create-label">
            {translate("Company Name")}
          </div>
          <input
            id="company-name-input"
            className="company-create-input"
            value={companyName}
            onChange={(e) => {
              setCompanyName(e.target.value);
            }}
          ></input>
        </div>
        <div className="company-create-field">
          <div className="company-create-label">
            {translate("Email Domain(s) (CSVs)")}
          </div>
          <input
            id="company-domain-input"
            className="company-create-input"
            value={companyEmailDomain}
            onChange={(e) => {
              setCompanyEmailDomain(e.target.value);
            }}
          ></input>
        </div>
        <div className="company-create-field">
          <div className="company-create-label">
            {translate("Head Office Address")}
          </div>
          <input
            id="company-address-input"
            className="company-create-input"
            value={companyAddress}
            onChange={(e) => {
              setCompanyAddress(e.target.value);
            }}
          ></input>
        </div>
        <div className="company-create-field">
          <div className="company-create-label">
            {translate("Head Office Region")}
          </div>
          <RegionSelect
            value={region}
            set={setRegion}
            options={locations.data}
            classType={"company-create-input"}
          />
        </div>
        <label className="company-edit-checkbox">
          <div className="company-edit-checkbox-text">
            {translate("Global (2+ Regions)")}
          </div>

          <input
            id="company-global-input"
            name={"consent"}
            type="checkbox"
            checked={isGlobal}
            onChange={(e) => {
              onConsent(e, setIsGlobal);
            }}
          />
          <span className="company-edit-checkbox-checkmark"></span>
        </label>
        <ModalSingle
          Component={CreateProjectSelectCostManager}
          setFunction={setAccountLead}
          label={translate("Arcadis Account Lead")}
          user={accountLead}
        />
      </div>
      <div className="general-row-container">
        <FileTray file={file} />
      </div>
      <div className="general-row-container">
        <ImageUpload
          imagePreview={existingLogo}
          setImage={setFile}
          setImagePreview={setExistingLogo}
          imageWidth={"200px"}
          imageHeight={"200px"}
          isContain={true}
          isBezierDisabled={true}
        />
      </div>
      <div className="general-row-container">
        <DisplayError error={error} setError={setError} />
      </div>
      <div className="general-button-container">
        <Upload data={data} uploadFile={uploadFile} />
      </div>
    </div>
  );
}

ModalSingle.propTypes = {
  Component: PropTypes.object,
  setFunction: PropTypes.func,
  label: PropTypes.string,
  user: PropTypes.object,
};

export function ModalSingle(props) {
  const { Component, setFunction, label } = props;
  const { user } = props;

  const [modal, setModal] = useState(false);

  return (
    <div className="pciu-col">
      <div className="pciu-row">
        <Modal
          // Modal Props
          title={label}
          Component={Component}
          modal={modal}
          setModal={setModal}
          // Component Props
          show={modal}
          setShow={setModal}
          setFunction={setFunction}
          label={label}
        />
        <button
          id="account-lead-button"
          className="pciu-modal-button"
          onClick={() => {
            setModal(true);
          }}
        >
          {label}
        </button>
        <DisplayNameUser user={user} />
      </div>
    </div>
  );
}
